import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { NgxFlagIconCssModule } from "ngx-flag-icon-css";
import { TranslateModule } from "@ngx-translate/core";

import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";

import { LanguageSelectComponent } from "./language-select.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxFlagIconCssModule,
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
  ],
  exports: [LanguageSelectComponent],
  declarations: [LanguageSelectComponent],
})
export class LanguageSelectModule {}
